import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const Cart = ({ className }) => (
    <svg
        className={classNames([
            {
                [className]: className !== null,
            },
        ])}
        xmlns="http://www.w3.org/2000/svg"
        width="20.8"
        height="20.8"
        viewBox="0 0 20.8 20.8"
        fill="currentColor"
    >
        <path d="M15.34,13.12c1.45,0,2.86-1.05,3.28-2.44l1.46-4.87c.24-.8,.11-1.61-.35-2.22-.46-.62-1.2-.97-2.03-.97H6.57l-.04-.42c-.09-.84-.53-1.54-1.2-1.91-.68-.37-1.5-.36-2.26,.01l-1.75,.87c-.64,.32-.91,1.11-.58,1.75,.32,.64,1.11,.91,1.75,.58l1.48-.74,1.09,12.62c-.88,.49-1.48,1.44-1.48,2.51,0,1.59,1.29,2.88,2.88,2.88s2.88-1.29,2.88-2.88c0-.09,0-.18-.01-.27h4.53c0,.09-.01,.18-.01,.27,0,1.59,1.29,2.88,2.88,2.88s2.88-1.29,2.88-2.88-1.21-2.8-2.73-2.88h0s-8.99-.01-8.99-.01l-.22-1.89h7.65Zm2.2-7.9l-1.41,4.71c-.08,.28-.49,.58-.79,.58H7.41l-.56-5.29h10.68Z" />
    </svg>
);

Cart.propTypes = propTypes;
Cart.defaultProps = defaultProps;

export default Cart;
